import Link from 'next/link';
import { Badge } from '@kcd/design-system';

import {
  ADDRESS_ROUTER,
  MYPAGE_ROUTER,
  NOTIFICATION_ROUTER,
  ORDERS_ROUTER,
} from '~/constants/router';
import { useUserCouponCount } from '~/domains/coupons/queries';

import { Quotation32x32Icon } from '~/assets/icons';
import AddressIcon from '~/assets/icons/ic_location_38x38.svg';
import CouponIcon from '~/assets/icons/icon_coupon_38x38.svg';
import OrdersIcon from '~/assets/icons/icon_order_38x38.svg';

type Props = {
  href: string;
  icon: React.ReactNode;
  title: string;
  count?: number;
};

const FrequentlyNavigationItem = ({ href, icon, title, count }: Props) => {
  return (
    <Link href={href} passHref>
      <div className="relative flex flex-col items-center justify-center">
        <div className="mb-4 flex size-48 items-center justify-center rounded-16 bg-secondary-air">
          {icon}
        </div>
        <span className="text-paragraph typo-caption100-semibold">{title}</span>
        {count !== undefined ? (
          <Badge
            type="number"
            text={count}
            className="absolute -right-4 -top-4"
          />
        ) : null}
      </div>
    </Link>
  );
};

export function FrequentlyNavigation() {
  const couponCount = useUserCouponCount();

  return (
    <div className="flex justify-between pt-8">
      <FrequentlyNavigationItem
        href={ORDERS_ROUTER.root}
        icon={<OrdersIcon />}
        title="주문내역"
      />
      <FrequentlyNavigationItem
        href={MYPAGE_ROUTER.coupons}
        icon={<CouponIcon />}
        title="할인쿠폰"
        count={couponCount}
      />
      <FrequentlyNavigationItem
        href={ADDRESS_ROUTER.root}
        icon={<AddressIcon />}
        title="배송지 관리"
      />
      <FrequentlyNavigationItem
        href={NOTIFICATION_ROUTER.rootWithFilter('estimate')}
        icon={<Quotation32x32Icon />}
        title="견적현황"
      />
    </div>
  );
}
